export default __webpack_public_path__ + "static/media/anthe-2023-static-banner-logo.cbbec1e3.png";